import { jsx as _jsx } from "react/jsx-runtime";
import { useQuery } from '@apollo/client';
import { ActivityValidationLevels } from 'common/enums/activity/activity-validation-levels.enum';
import { REQUEST_ACTIVITY_VALIDATION_INFO } from 'common/graphql/queries/activity/request-activity-validation-info';
import CircularProgressMui from 'components/Loading/CircularProgresMui';
import { useEffect, useState } from 'react';
import RequestActivityValidationDialogCreateForm from './RequestActivityValidationDialogCreateForm';
import RequestActivityValidationDialogPickLevel from './RequestActivityValidationDialogPickLevel';
var RequestActivityValidationDialog = function (_a) {
    var activity = _a.activity, handleClose = _a.handleClose;
    var _b = useState(0), step = _b[0], setStep = _b[1];
    var _c = useState(ActivityValidationLevels.Base), level = _c[0], setLevel = _c[1];
    var _d = useState(undefined), sportEvent = _d[0], setSportEvent = _d[1];
    var _e = useQuery(REQUEST_ACTIVITY_VALIDATION_INFO, {
        variables: {
            activityId: activity.id
        }
    }), data = _e.data, loading = _e.loading;
    useEffect(function () {
        if (data && data.requestActivityValidationInfo.sportEvents.length === 0) {
            setStep(1);
        }
    }, [data]);
    if (loading)
        return _jsx(CircularProgressMui, {}, void 0);
    if (!loading && step === 0 && data && data.requestActivityValidationInfo.sportEvents.length > 0) {
        return (_jsx(RequestActivityValidationDialogPickLevel, { sportEvets: data.requestActivityValidationInfo.sportEvents, setLevel: setLevel, setStep: setStep, setSportEvent: setSportEvent }, void 0));
    }
    if (!loading && step === 1 && data) {
        return (_jsx(RequestActivityValidationDialogCreateForm, { hasGoBackButton: data.requestActivityValidationInfo.sportEvents.length > 0, activity: activity, handleClose: handleClose, level: level, setStep: setStep, sportEvent: sportEvent }, void 0));
    }
    return null;
};
export default RequestActivityValidationDialog;
